import React from "react";
import { Paper, Button, withStyles } from "@material-ui/core";
import styles from "./recommendationStyles";
import RecommendationDetailsTable from "./RecommendationDetailsTable";
import RouteOnCard from "./RouteOnCard";
import constants from "../constants";
import Tooltip from "../../../../../common/StyledToolTip";
import { DRIVER_EVENTS,SHOW_DRIVER_EVENTS } from "../../constants"
import { sortStopsBySequence, getCurrentDriverStatus } from "../../../utils/utils";

const getDriverStatus = (data) => {
  const stopsWithoutDelays = sortStopsBySequence(data?.routeStops);
  if (
    data?.currentStatus &&
    [DRIVER_EVENTS.ArrivedAtStop, DRIVER_EVENTS.EnrouteToStop].includes(
      data.currentStatus.status
    )
  ) {
    return getCurrentDriverStatus({
      currentStatus: data.currentStatus,
      stops: stopsWithoutDelays,
    });
  }
  const nextStop = stopsWithoutDelays?.findIndex(
    (stop) => !stop.isStopCompleted
  );
  return nextStop > -1
    ? `${SHOW_DRIVER_EVENTS.NextEnrouteTo} ${stopsWithoutDelays[nextStop].name}`
    : "";
};

const DriverRecommendationCard = ({
  classes,
  data,
  onClick,
  recommendationButtonLabel,
  kpiBorderClass = undefined,
  highlightPreviewCard = false,
}) => {
  const driverStatus = getDriverStatus(data);
  return (
    <Paper className={`${classes.recommendationContainer} ${kpiBorderClass} ${highlightPreviewCard ? classes.highlightBoarder: ''}`}>
      <div className={classes.recommendedDrivers}>
        <div className={classes.upperDetails}>
          <div className={classes.routeIcon}>
            <RouteOnCard color={data.color} />
          </div>
          <div className={`${classes.detailsContainer} ${onClick ? "": classes.width100 }`}>
            <div className={classes.bestChoiceSection}>
              <div
                className={
                  data.recommendationRank === 1
                    ? classes.driverNameContainerWithBestChoice
                    : classes.driverNameContainer
                }>
                <Tooltip title={`${data.driverName} (${data.driverNumber})`} classes={{popper: classes.tooltip}}>
                  <span className={classes.driverName}>
                    {data.driverName} ({data.driverNumber})
                  </span>
                </Tooltip>
              </div>
              {onClick && data.recommendationRank === 1 && (
                <span className={classes.bestChoice}>(Best Choice)</span>
              )}
            </div>
            <div className={classes.upperEnrouteToTitle}>{driverStatus}</div>
          </div>
          {onClick && (
            <Button
              color="primary"
              variant="contained"
              size="small"
              classes={{
                root: classes.assignBtn,
                disabled: classes.disabledButton
              }}
              disabled={highlightPreviewCard}
              onClick={onClick}>
              {recommendationButtonLabel || constants.RECOMMENDATION_BUTTON_LABEL.ASSIGN}
            </Button>
          )}
        </div>
        <div className={classes.lowerDetails}>
          <RecommendationDetailsTable data={data} />
        </div>
      </div>
    </Paper>
  );
};

export default withStyles(styles)(DriverRecommendationCard);
